import { createContext, useContext } from 'react';
import { RecordType } from '@xbcb/shared-types';

export interface AppRecordContextValue {
  recordId: string;
  recordType: RecordType | null;
  updateLoading: boolean;
  taskActivelyInProgress: boolean;
  // True while a large entry's referenced data is downloading from S3.
  referenceLoading: boolean;
  setReferenceLoading: (loading: boolean) => void;
}

export const defaultValues: AppRecordContextValue = {
  recordId: '',
  recordType: null,
  updateLoading: false,
  taskActivelyInProgress: false,
  referenceLoading: false,
  setReferenceLoading: () => undefined,
};

export const AppRecordContext =
  createContext<AppRecordContextValue>(defaultValues);

export const useAppRecordContext = (): AppRecordContextValue => {
  const {
    recordId,
    recordType,
    updateLoading,
    taskActivelyInProgress,
    referenceLoading,
    setReferenceLoading,
  } = useContext(AppRecordContext);
  return {
    recordId,
    recordType,
    updateLoading, // The save button has been pressed; all actions disabled while update mutation is in flight
    taskActivelyInProgress,
    referenceLoading,
    setReferenceLoading,
  };
};
